import React, { useState, useEffect, Fragment } from "react";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { Table, TableBody, TableContainer, Typography } from "@mui/material";
import { StyledButton, StyledTableCell, StyledTableRow } from "./styles";

// Mock Data
import {
  parList,
  holesList,
  indexList,
  getMiddleRow,
  getFinalPayloadData,
  getPlayerWithBenefit,
  getModifiedCourseLists,
  generatePlayersMockData,
  autoScoreFiller,
  fillScoreForEdit,
  reImplementBenefitOn,
} from "./mockData";

// SMP Components
import CourseInfo from "./Components/CourseInfo";
import WinnerModal from "./Components/WinnerModal";
import MainModal from "../../components/MainModal";
import ArrowStatus from "./Components/ArrowStatus";
import OpponentName from "./Components/OpponentName";
import CustomSelectTag from "./Components/CustomSelectTag";
import ScoreInput from "./Components/ScoreInput";
import IndexParList from "./Components/IndexParList";

// Actions
import { getMinimalCourseList } from "../../redux/actions/courses-action";
import {
  clearIndexParList,
  getCourseIndexPar,
} from "../../redux/actions/smp-action/get-course-index-par-action";
import { submitScore } from "../../redux/actions/smp-action/submit-score-action";
import {
  clearScoreCard,
  getScore,
} from "../../redux/actions/smp-action/get-score-actions";

const ScoreboardTableEdit = ({ handicapDifferential, setIsEdit }) => {
  const dispatch = useDispatch();
  const { id: match_id } = useParams();
  const { state } = useLocation();
  let modifiedIndexParList,
    benefitOn = [],
    out1 = [],
    in1 = [],
    out2 = [],
    in2 = [];
  const _teeState = {
    _id: "",
    handicap_value: 0,
    tee_color: "initial",
    is_deafult: "",
  };

  const playerHandicap = +handicapDifferential?.match(/(\d+)/)[0];

  // Selectors
  const submitScoreSelector = useSelector((state) => state.submitScoreReducer);
  const courseListSelector = useSelector((state) => state.coursesReducer);
  const getScoreSelector = useSelector((state) => state.getScoreReducer);
  const groupsAndTeesSelector = useSelector(
    (state) => state.groupsAndTeesReducer
  );
  const courseParIndexSelector = useSelector(
    (state) => state.getCourseParIndex
  );

  // Local States
  const [courseInfo, setCourseInfo] = useState({
    name: "Course Name",
    date: "",
    time: "",
  });
  const [scoreUpCount, setScoreUpCount] = useState([]);
  const [matchesGroup, setMatchesGroup] = useState([]);
  const [finalWinner, setFinalWinner] = useState(null);
  const [tieOpenModal, setTieOpenModal] = useState(false);
  const [groupsAndTees, setGroupsAndTees] = useState(null);
  const [scoreUp, setScoreUp] = useState(false);
  const [onSD, setOnSD] = useState(null);
  const [isShown, setIsShown] = useState(false);
  const [groupScore, setGroupScore] = useState({ group1: [], group2: [] });
  const [runIndex, setRunIndex] = useState(null);
  const [benefittedArray, setBenefittedArray] = useState([]);
  const [teeInfo, setTeeInfo] = useState({
    group1: _teeState,
    group2: _teeState,
  });
  const getScoresForEdit = getScoreSelector?.data?.roundMatchData[0];

  const handlePlayerScore = (value, index, playerNo, benefit) => {
    setIsShown(true);
    const filteredScore1 = groupScore.group1.filter((el) => el.score != "");
    const filteredScore2 = groupScore.group2.filter((el) => el.score != "");

    if (filteredScore1.length == 18 && filteredScore2.length == 18) {
      setRunIndex(index);
    }

    if (courseInfo.name != "Course Name") {
      setIsShown(false);
      setGroupScore((prev) => {
        const foundItem = prev[playerNo].find((pl) => pl.id == index);
        if (foundItem) {
          const x = prev[playerNo].map((pl) => {
            if (pl.id == foundItem.id)
              return {
                ...pl,
                score: value == "" ? "" : +value,
                benefit: benefit == undefined ? false : benefit,
              };
            return { ...pl };
          });

          return { ...prev, [playerNo]: x };
        } else {
          return {
            ...prev,
            [playerNo]: [
              ...prev[playerNo],
              {
                id: index,
                score: +value,
                benefit: benefit == undefined ? false : benefit,
              },
            ],
          };
        }
      });
    } else if (!isShown) toast.warning("Please select the course first");
  };

  const handleChangeTee = (newTeeInfo, key) =>
    setTeeInfo((prev) => ({ ...prev, [key]: { ...newTeeInfo } }));

  const handleChangeCourseInfo = (value, key) =>
    setCourseInfo((prev) => ({ ...prev, [key]: value }));

  const playerWithBenefit = getPlayerWithBenefit(
    teeInfo.group1.handicap_value,
    teeInfo.group2.handicap_value,
    playerHandicap / 100
  );

  if (
    !courseParIndexSelector?.loading &&
    !courseParIndexSelector?.status?.error &&
    courseParIndexSelector?.status?.index_par?.length > 0
  ) {
    modifiedIndexParList = getModifiedCourseLists(
      courseParIndexSelector.status.index_par
    );

    for (let i = 0; i < 18; i++) {
      if (benefittedArray.length > 0) {
        benefitOn.push(benefittedArray[i]);
      } else {
        if (courseParIndexSelector?.status?.index_par[i]?.index != undefined) {
          if (
            playerWithBenefit.benefitOf >=
            courseParIndexSelector?.status?.index_par[i]?.index
          )
            benefitOn.push({ benefittedIndex: i + 1, hasBenefit: true });
          else benefitOn.push({ benefittedIndex: i + 1, hasBenefit: false });
        }
      }
    }
  }

  const handleSubmitScore = () => {
    if (groupScore.group1.length == 18 && groupScore.group2.length == 18) {
      const hasValidScore1 = groupScore.group1.every((val) => val.score > 0);
      const hasValidScore2 = groupScore.group2.every((val) => val.score > 0);
      const scCount = scoreUpCount.filter((s) => s.hole != "label");

      const { group1Scores, group2Scores, scoreUplabel, adjScore1, adjScore2 } =
        getFinalPayloadData(
          groupScore,
          courseParIndexSelector,
          scoreUpCount,
          modifiedIndexParList
        );

      const score_up_group =
        scoreUplabel == "group1"
          ? "group1"
          : scoreUplabel == "group2"
          ? "group2"
          : finalWinner;
      const score_up_value =
        scoreUplabel == "group1" || scoreUplabel == "group2"
          ? `${scoreUpCount[scoreUpCount.length - 1].count}UP`
          : "SD";

      // Final Object
      const scorePayload = {
        match_id,
        round_id: state?._id,
        league_id: state?.league_id,
        groupsdata: {
          course_id: courseInfo.name,
          time: courseInfo.time,
          date: courseInfo.date,
          ...(hasValidScore1 &&
            hasValidScore2 && {
              score_up_group,
              won: score_up_group,
              score_up: scoreUplabel != "tie",
              score_up_value,
              sudden_death: scoreUplabel == "tie",
              match_status_track: scCount,
            }),
          ...(onSD != null && { autoScoreHoles: onSD }),

          group1: [
            {
              user_id: matchesGroup[0].user_id,
              name: matchesGroup[0].name,
              tee: teeInfo.group1.tee_color,
              playing_handicap: teeInfo.group1.handicap_value,
              gross_score: groupScore.group1.reduce(
                (acc, val) => acc + +val.score,
                0
              ),
              adjusted_score: adjScore1,
              mp_score: group1Scores,
            },
          ],

          group2: [
            {
              user_id: matchesGroup[1].user_id,
              name: matchesGroup[1].name,
              tee: teeInfo.group2.tee_color,
              playing_handicap: teeInfo.group2.handicap_value,
              gross_score: groupScore.group2.reduce(
                (acc, val) => acc + +val.score,
                0
              ),
              adjusted_score: adjScore2,
              mp_score: group2Scores,
            },
          ],
        },
      };

      if (!hasValidScore1 && !hasValidScore1) {
        toast.success("Information saved without score");
      } else {
        toast.success("Complete Scorecard is saved");
      }

      dispatch(submitScore(scorePayload));
    }
  };

  if (groupScore.group1.length > 0) {
    groupScore.group1.map((pl) => {
      if (pl.id > 9) in1.push(pl);
      else if (pl.id <= 9) out1.push(pl);
    });
  }

  if (groupScore.group2.length > 0) {
    groupScore.group2.map((pl) => {
      if (pl.id > 9) in2.push(pl);
      else if (pl.id <= 9) out2.push(pl);
    });
  }

  const handleDecideWinner = (player) => {
    setFinalWinner(player);
    setTieOpenModal(false);
    setScoreUp(false);
  };

  useEffect(() => {
    setRunIndex(null);
    dispatch(clearIndexParList());
    if (match_id != null && state != null) {
      const postPayload = { round_id: state._id, match_id };
      dispatch(getScore(postPayload));
    }
    const { score1List, score2List } = generatePlayersMockData();
    setGroupScore({ group1: score1List, group2: score2List });
    dispatch(getMinimalCourseList());

    return () => dispatch(clearScoreCard());
  }, []);

  useEffect(() => {
    if (
      !groupsAndTeesSelector?.loading &&
      !groupsAndTeesSelector?.status?.error &&
      groupsAndTeesSelector?.status?.groupsData?.length > 0
    ) {
      setGroupsAndTees(groupsAndTeesSelector.status.groupsData[0]);

      if (getScoresForEdit?.matches?.group1[0].mp_score.length > 0) {
        setTeeInfo({
          group1: {
            handicap_value: getScoresForEdit.matches.group1[0].playing_handicap,
            tee_color: getScoresForEdit.matches.group1[0].tee,
          },
          group2: {
            handicap_value: getScoresForEdit.matches.group2[0].playing_handicap,
            tee_color: getScoresForEdit.matches.group2[0].tee,
          },
        });
      } else {
        const isDefaultTee1 =
          groupsAndTeesSelector.status.groupsData[0].tees_1.filter(
            (val) => val.is_default
          );
        const isDefaultTee2 =
          groupsAndTeesSelector.status.groupsData[0].tees_2.filter(
            (val) => val.is_default
          );

        setTeeInfo({
          group1: { ...isDefaultTee1[0] },
          group2: { ...isDefaultTee2[0] },
        });
      }

      setMatchesGroup(
        groupsAndTeesSelector.status.groupsData[0].matches?.matchGroups
      );
    }
  }, [groupsAndTeesSelector]);

  useEffect(() => {
    if (courseInfo.name != "Course Name") {
      dispatch(getCourseIndexPar(courseInfo.name));
    }
  }, [courseInfo, dispatch]);

  useEffect(() => {
    if (getScoresForEdit?.matches?.group1[0]?.mp_score.length > 0) {
      setCourseInfo({
        name: getScoresForEdit.matches.course_id,
        date: getScoresForEdit.matches.date,
        time: getScoresForEdit.matches.time,
      });

      const sc1 = fillScoreForEdit(getScoresForEdit.matches.group1[0].mp_score);
      const sc2 = fillScoreForEdit(getScoresForEdit.matches.group2[0].mp_score);
      setGroupScore({ group1: sc1, group2: sc2 });

      if (getScoresForEdit?.matches?.score_up)
        setScoreUp(getScoresForEdit?.matches?.score_up);

      if (onSD == null) setOnSD(getScoresForEdit.matches.autoScoreHoles);

      if (
        getScoresForEdit?.matches?.match_status_track != undefined &&
        getScoresForEdit?.matches?.match_status_track.length == 18 &&
        getScoresForEdit?.matches?.match_status_track[17].label == "tie"
      ) {
        setFinalWinner(getScoresForEdit.matches.score_up_group);
      } else setFinalWinner(null);
    }
  }, [getScoreSelector]);

  useEffect(() => {
    const totalHoles = 18;

    const { rowCount, countUp, toFill, loopStart, valueSD } = getMiddleRow(
      groupScore,
      runIndex
    );
    setScoreUpCount(rowCount);

    if (runIndex != null && countUp > 0) setFinalWinner(null);

    const ls = totalHoles - loopStart;
    if (toFill) {
      if (valueSD != null) setOnSD(valueSD);

      const { benefitArr } = reImplementBenefitOn(
        teeInfo,
        courseParIndexSelector,
        ls + 1,
        benefitOn
      );

      setBenefittedArray(benefitArr);

      autoScoreFiller(
        ls + 1,
        totalHoles,
        "group1",
        playerWithBenefit.awardedTo,
        handlePlayerScore,
        benefitOn,
        courseParIndexSelector,
        teeInfo.group1.handicap_value
      );
      autoScoreFiller(
        ls + 1,
        totalHoles,
        "group2",
        playerWithBenefit.awardedTo,
        handlePlayerScore,
        benefitOn,
        courseParIndexSelector,
        teeInfo.group2.handicap_value
      );
    }
  }, [groupScore]);

  useEffect(() => {
    if (runIndex != null) {
      const { group1, group2 } = groupScore;
      let g1Score = group1;
      let g2Score = group2;
      const { newLoopStarter } = getMiddleRow(groupScore);

      const { score1List, score2List } = generatePlayersMockData();
      setGroupScore({ group1: score1List, group2: score2List });
      setRunIndex(null);
      setBenefittedArray([]);

      for (let i = 0; i < newLoopStarter; i++) {
        handlePlayerScore(
          g1Score[i].score,
          g1Score[i].id,
          "group1",
          g1Score[i].benefit
        );
      }
      for (let i = 0; i < newLoopStarter; i++) {
        handlePlayerScore(
          g2Score[i].score,
          g2Score[i].id,
          "group2",
          g2Score[i].benefit
        );
      }
    }
  }, [runIndex]);

  useEffect(() => {
    if (scoreUpCount != undefined && scoreUpCount.length == 19) {
      if (scoreUpCount[18].label == "tie") setScoreUp(false);
      if (scoreUpCount[18].label == "tie" && finalWinner == null && !scoreUp) {
        setTieOpenModal(true);
      }
    }
  }, [scoreUpCount]);

  useEffect(() => {
    const player = playerWithBenefit.awardedTo;

    for (let i = 0; i < groupScore[player].length; i++) {
      if (benefitOn.length > 0) {
        handlePlayerScore(
          groupScore[player][i].score,
          i + 1,
          player,
          benefitOn[i].hasBenefit
        );
      }
    }
  }, [courseParIndexSelector]);

  useEffect(() => {
    if (
      !submitScoreSelector?.loading &&
      submitScoreSelector?.data?.error != undefined
    ) {
      setFinalWinner(null);
      setScoreUpCount([]);
      setTieOpenModal(false);
      setOnSD(null);
      setGroupScore({ group1: [], group2: [] });
      setOnSD(null);
      benefitOn.length = 0;
      setIsEdit((prev) => !prev);
    }
  }, [submitScoreSelector]);

  return (
    <Fragment>
      <TableContainer sx={{ padding: 5 }}>
        <Table sx={{ padding: "0 !important" }}>
          <TableBody>
            <StyledTableRow>
              <StyledTableCell sx={{ width: "180px" }} rowSpan={3}>
                <CourseInfo
                  groupScore={groupScore}
                  courseListSelector={courseListSelector}
                  handleChangeCourseInfo={handleChangeCourseInfo}
                  courseInfo={courseInfo}
                />
              </StyledTableCell>

              <IndexParList
                modifiedIndexParList={modifiedIndexParList}
                staticList={holesList}
                dynamicList={modifiedIndexParList?.holesList}
              />
            </StyledTableRow>

            <StyledTableRow>
              <IndexParList
                modifiedIndexParList={modifiedIndexParList}
                staticList={indexList}
                dynamicList={modifiedIndexParList?.indexList}
              />
            </StyledTableRow>

            <StyledTableRow>
              <IndexParList
                modifiedIndexParList={modifiedIndexParList}
                staticList={parList}
                dynamicList={modifiedIndexParList?.parList}
              />
            </StyledTableRow>

            {/* 1st opp*/}
            <StyledTableRow>
              <StyledTableCell align="center">
                <OpponentName
                  value={
                    matchesGroup.length > 0
                      ? matchesGroup[0].name
                      : "Loading..."
                  }
                  color="#0000FF"
                />
              </StyledTableCell>
              <StyledTableCell align="center">
                <CustomSelectTag
                  handleChangeTee={handleChangeTee}
                  playerInfo={teeInfo.group1}
                  teesList={groupsAndTees?.tees_1}
                  playerNo="group1"
                  disable={
                    groupScore.group1.filter((el) => el.score != "").length >=
                      1 ||
                    groupScore.group2.filter((el) => el.score != "").length >= 1
                  }
                />
              </StyledTableCell>

              <ScoreInput
                onSD={onSD}
                group="group1"
                playerWithBenefit={playerWithBenefit}
                benefitOn={benefitOn}
                groupScore={groupScore}
                handlePlayerScore={handlePlayerScore}
                position="in"
              />

              <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                {out1.reduce((acc, val) => acc + +val.score, 0)}
              </StyledTableCell>

              <ScoreInput
                onSD={onSD}
                group="group1"
                playerWithBenefit={playerWithBenefit}
                benefitOn={benefitOn}
                groupScore={groupScore}
                handlePlayerScore={handlePlayerScore}
                position="out"
              />

              <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                {in1.reduce((acc, val) => acc + +val.score, 0)}
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                {groupScore.group1.reduce((acc, val) => acc + +val.score, 0)}
              </StyledTableCell>
            </StyledTableRow>

            {/* vs row  start*/}
            <StyledTableRow>
              <StyledTableCell align="center">
                <OpponentName value="vs" color="#000" />
              </StyledTableCell>
              <StyledTableCell align="center"></StyledTableCell>

              {scoreUpCount?.map(({ label, count }) => {
                return label == "tie" ? (
                  <StyledTableCell align="center">-</StyledTableCell>
                ) : label == "group2" ? (
                  <StyledTableCell align="center">
                    <ArrowStatus value={count} color="#FF0000" />
                  </StyledTableCell>
                ) : label == "group1" ? (
                  <StyledTableCell align="center">
                    <ArrowStatus value={count} color="#0000FF" />
                  </StyledTableCell>
                ) : (
                  label == "" && (
                    <StyledTableCell align="center"></StyledTableCell>
                  )
                );
              })}

              {[...Array(Number(19 - scoreUpCount?.length))].map(() => (
                <StyledTableCell align="center"></StyledTableCell>
              ))}

              {!scoreUp && finalWinner != null ? (
                <StyledTableCell align="center" colspan={2}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: finalWinner == "group1" ? "#0000FF" : "#FF0000",
                    }}
                  >
                    Won in playoff
                  </Typography>
                </StyledTableCell>
              ) : (
                <>
                  <StyledTableCell align="center"></StyledTableCell>
                  <StyledTableCell align="center"></StyledTableCell>
                </>
              )}
            </StyledTableRow>

            {/* 2nd opp*/}
            <StyledTableRow>
              <StyledTableCell align="center">
                <OpponentName
                  value={
                    matchesGroup.length > 0
                      ? matchesGroup[1].name
                      : "Loading..."
                  }
                  color="#FF0000"
                />
              </StyledTableCell>
              <StyledTableCell align="center">
                <CustomSelectTag
                  handleChangeTee={handleChangeTee}
                  playerInfo={teeInfo.group2}
                  teesList={groupsAndTees?.tees_2}
                  playerNo="group2"
                  disable={
                    groupScore.group1.filter((el) => el.score != "").length >=
                      1 ||
                    groupScore.group2.filter((el) => el.score != "").length >= 1
                  }
                />
              </StyledTableCell>

              <ScoreInput
                onSD={onSD}
                group="group2"
                playerWithBenefit={playerWithBenefit}
                benefitOn={benefitOn}
                groupScore={groupScore}
                handlePlayerScore={handlePlayerScore}
                position="in"
              />

              <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                {out2.reduce((acc, val) => acc + +val.score, 0)}
              </StyledTableCell>

              <ScoreInput
                onSD={onSD}
                group="group2"
                playerWithBenefit={playerWithBenefit}
                benefitOn={benefitOn}
                groupScore={groupScore}
                handlePlayerScore={handlePlayerScore}
                position="out"
              />

              <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                {in2.reduce((acc, val) => acc + +val.score, 0)}
              </StyledTableCell>
              <StyledTableCell sx={{ fontWeight: 700 }} align="center">
                {groupScore.group2.reduce((acc, val) => acc + +val.score, 0)}
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <StyledButton
        onClick={handleSubmitScore}
        loading={submitScoreSelector?.loading}
        disabled={submitScoreSelector?.loading}
      >
        Save
      </StyledButton>

      <MainModal
        show={tieOpenModal}
        closeModal={() => setTieOpenModal(false)}
        modalHeadTitle="Final Result"
        variant="contained"
        width="400px"
        showBtn={false}
      >
        <WinnerModal
          handleDecideWinner={handleDecideWinner}
          group1={matchesGroup[0]?.name}
          group2={matchesGroup[1]?.name}
        />
      </MainModal>
    </Fragment>
  );
};

export default ScoreboardTableEdit;
